<template>
  <div class="row">
    <div class="flex xs10 offset--xs1">
      <va-card :title="title">
        <div class="row">
          <div class='flex md12 sm6 xs12'>
            <va-input
              v-model='insertData.id'
              v-show="showId"
              label='id'
              disabled
            />
          </div>
          <div class='flex md12 sm6 xs12'>
            <va-input
              v-model='insertData.uid'
              v-show="showUid"
              label='uid'
              disabled
            />
          </div>
          <div class="flex md8 sm6 xs12">
            <va-select
              label="导师"
              v-model="insertData.mentorUid"
              :options="computedMentors"
              :disabled="disableMentor"
            />
          </div>
          <div class="flex md4 sm6 xs12">
            <va-input
              v-model="insertData.createTime"
              v-show="showCreateTime"
              label="创建时间"
              disabled
            />
          </div>
          <div class="flex md12 sm6 xs12">
            <va-input
              v-model="insertData.topic"
              type="textarea"
              label="咨询话题"
              removable
              :messages="message"
              :error="!!error.topicErrors.length"
              :error-messages="error.topicErrors"
            />
          </div>
          <div class="flex md12 sm6 xs12">
            <va-input
              v-model="insertData.description"
              label="话题详情"
              type="textarea"
              removable
              :messages="message"
              :error="!!error.descriptionErrors.length"
              :error-messages="error.descriptionErrors"
            />
          </div>
          <div class="flex md4 sm6 xs12">
            <va-input
              v-model="insertData.duration"
              label="咨询时长(分钟)"
              removable
              type="number"
              :error="!!error.durationErrors.length"
              :error-messasge="error.durationErrors"
            />
          </div>
          <div class="flex md4 sm6 xs12">
            <va-input
              v-model="insertData.price"
              label="咨询价格"
              removable
              :error="!!error.priceErrors.length"
              :error-messasge="error.priceErrors"
            />
          </div>

          <div class="flex md4 sm6 xs12">
            <va-input
              v-model="insertData.sortNum"
              label="排序"
              placeholder="数字越大越靠前"
              removable
              type="number"
              oninput="if(value <0)value=1"
              :min="1"
              :messages="message"
              :error="!!error.sortNumErrors.length"
              :error-messages="error.sortNumErrors"
            />
          </div>
        </div>
        <div class="flex md2 offset--md5">
          <va-button class="ma-0" color="primary" slot="trigger" @click="clickSubmit" :disabled="!submitButtonStatus">
            submit
          </va-button>
        </div>
      </va-card>
    </div>
  </div>
</template>

<script>

import 'vue-trix'
import { copyObject, formatTime } from '../../utils/common'
import consultingApi from '../../api/consulting'
import userApi from '../../api/user'
import mentorApi from '../../api/mentor'

export default {
  data () {
    return {
      insertData: {
        id: null,
        uid: null,
        topic: '',
        duration: '',
        price: '',
        description: '',
        sortNum: null,
        mentorUid: null,
        createTime: '',
      },
      message: ['Required field'],
      referralTags: [],
      mentors: [],
      error: {
        topicErrors: [],
        durationErrors: [],
        priceErrors: [],
        statusErrors: [],
        sortNumErrors: [],
        descriptionErrors: [],
      },
      showId: false,
      showUid: false,
      showCreateTime: false,
      disableMentor: false,
      title: '新增导师咨询',
      statusOptions: ['已发布', '已下架'],
      submitButtonStatus: true,

    }
  },
  created () {
    const params = this.$route.params
    if (params.uid != null) {
      this.showId = true
      this.showUid = true
      this.showCreateTime = true
      this.disableMentor = true
      this.title = '编辑导师咨询'
      // 通过id获取详情
      consultingApi.getConsulting(params.uid).then(response => {
        copyObject(response.consulting, this.insertData)
        this.insertData.createTime = formatTime(this.insertData.createTime)
        // eslint-disable-next-line no-prototype-builtins
        if (response.consulting.mentorUid != null) {
          userApi.getUser(response.consulting.mentorUid).then(response => {
            this.insertData.mentorUid = response.user.nickname + response.user.uid
          })
        }
        if (response.consulting.duration != null) {
          this.insertData.duration = parseInt(response.consulting.duration)
        }
      }).catch(error => {
        this.showToast(error.msg, {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      })
    }
    this.listMentor()
  },
  computed: {
    formReady () {
      return !this.error.topicErrors.length &&
          !this.error.priceErrors.length &&
          !this.error.durationErrors.length &&
          !this.error.sortNumErrors.length &&
          !this.error.descriptionErrors.length
    },
    computedMentors () {
      return this.mentors.map(x => {
        return x.nickname + x.uid
      })
    },
    flipMentors () {
      const flipMentors = {}
      this.mentors.forEach(x => {
        flipMentors[x.nickname + x.uid] = x.uid
      })
      return flipMentors
    },
  },
  methods: {
    listMentor () {
      const params = {
        pageNumber: 1,
        pageSize: 1000,
      }
      mentorApi.listMentor(params).then(response => {
        this.mentors = response.mentors
      }).catch(error => {
        console.log(error)
      })
    },
    clickSubmit () {
      this.checkField()
      if (!this.formReady) {
        return
      }
      this.changeButtonStatus(false)
      const data = {
        topic: this.insertData.topic,
        uid: this.insertData.uid,
        price: this.insertData.price,
        duration: this.insertData.duration + '分钟',
        description: this.insertData.description,
        sortNum: this.insertData.sortNum !== null ? this.insertData.sortNum : 1,
      }
      if (this.insertData.uid != null) {
        data.uid = this.insertData.uid
        consultingApi.updateConsulting(data.uid, data).then(response => {
          if (response.success === true) {
            this.showToast('更新成功', {
              duration: 1000,
              icon: 'fa-check',
              position: 'top-center',
              fullWidth: false,
            })
            this.$router.push({ name: 'listConsulting' })
          }
        }).catch(error => {
          this.showToast(error.msg, {
            duration: 1000,
            icon: 'fa-warning',
            position: 'top-center',
            fullWidth: false,
          })
          this.changeButtonStatus(true)
        })
      } else {
        data.mentorUid = this.flipMentors[this.insertData.mentorUid]
        consultingApi.saveConsulting(data).then(response => {
          if (response.success === true) {
            this.showToast('保存成功', {
              duration: 1000,
              icon: 'fa-check',
              position: 'top-center',
              fullWidth: false,
            })
            this.$router.push({ name: 'listConsulting' })
          }
        }).catch(error => {
          this.changeButtonStatus(true)
          this.showToast(error.msg, {
            duration: 1000,
            icon: 'fa-warning',
            position: 'top-center',
            fullWidth: false,
          })
        })
      }
    },
    clickCancel () {
    },
    checkField () {
      this.error.statusErrors = this.insertData.status ? [] : ['status is required']
      this.error.priceErrors = this.insertData.price ? [] : ['price is required']
      this.error.durationErrors = this.insertData.duration ? [] : ['duration is required']
      this.error.topicErrors = this.insertData.topic ? [] : ['topic is required']
      this.error.sortNumErrors = this.insertData.sortNum ? [] : ['sortNum is required']
      this.error.descriptionErrors = this.insertData.description ? [] : ['description is required']
    },
    changeButtonStatus (status) {
      this.submitButtonStatus = status
    },
  },
}

</script>

<style>
.va-card-image {
  height: 200px;
  width: 200px;
  border-radius: 5%;
  margin-bottom: 10px;
}
</style>
